export const CompanyScreen = () => {
  return <></>;
};
